import React, { useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { listDynKeTranscriptPreparedRemarksAiBullets } from "../../../graphql_ap/queries";
import { styled } from '@mui/material/styles';

const StyledListItem = styled('li')(({ theme, isSelected }) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  // fontWeight: isSelected ? 'bold' : 'normal',
  color: isSelected ? theme.palette.ke.link_hover : 'inherit',
  backgroundColor: isSelected ? '#EEF4FB' : 'inherit', 
}));

const PreparedRemarksBlock = (props) => {

    const [preparedRemarksAIBulletsTable, setPreparedRemarksAIBulletsTable] = useState([]);

    useEffect(() => {
        async function fetchData() {
          if (props.prepared_remarks_id) {
            try {
              const preparedRemarksAIBulletsData = await API.graphql(
                graphqlOperation(listDynKeTranscriptPreparedRemarksAiBullets, {
                    prepared_remarks_id: props.prepared_remarks_id, 
                })
              );
              const preparedRemarksAIBulletsDataList = preparedRemarksAIBulletsData.data.listDynKeTranscriptPreparedRemarksAiBullets;
    
              setPreparedRemarksAIBulletsTable(preparedRemarksAIBulletsDataList.map(item => ({
                ...item,
                id: item.prepared_remarks_bullet_num 
              })));
            } catch (error) {
              console.error("Error fetching prepared remarks table:", error);
            }
          }
        }
    
        fetchData();
      }, [props.prepared_remarks_id]);

      const itemClickHandler= (bullet) => {
        const itemId = `PreparedRemarksBlock-${bullet.id}`;
        if (props.selectedItemId === itemId) {
          // Deselect the item
          props.onSelectItem(null);
          props.onUtteranceNumListSelect([]);
        } else {
          // Select the item
          props.onSelectItem(itemId);
          props.onUtteranceNumListSelect(bullet.utterance_num_list);
        }
      }

    return (
        <div>
            <p><b>{props.speaker_name} - {props.speaker_title}</b></p>
            {preparedRemarksAIBulletsTable
              .sort((a, b) => a.id - b.id)
              .map((bullet, index) => {
                const isSelected = `PreparedRemarksBlock-${bullet.id}` === props.selectedItemId;
                return (
                <div key={index}>
                  <ul>
                  <StyledListItem onClick={() => itemClickHandler(bullet)}
                  isSelected={isSelected}
                  >
                    {bullet.ai_bullet_text}
                    </StyledListItem>
                  </ul>
                </div>
                );
            })
            }
        </div>
    );
};

export default PreparedRemarksBlock;